import { Component } from '@angular/core';
import { TrackingService } from '@app/@shared/services/tracking.service';
import { WalletService } from '@app/@shared/services/wallet.service';

@Component({
  selector: 'app-not-alowed',
  templateUrl: './not-alowed.component.html',
  styleUrl: './not-alowed.component.scss',
})
export class NotAlowedComponent {
  constructor(public walletS: WalletService, private trackingS: TrackingService) {
    this.trackingS.trackEvent('not_allowed', {}, false, false);
  }
}
